module.exports = __webpack_public_path__ + "img/grill-bratwurst.b29cb772.png";